// Core
import React, { FC } from 'react';
import { createPortal } from 'react-dom';
import { PieBar } from "../../../components/Charts";

const EmployeesAge: FC = () => {
  const params = new URLSearchParams(window.location.search)

  const apiParams = {
    name: "employees_age",
    ot: params.get('ot'),
    date_from: params.get('date_from'),
    date_to: params.get('date_to'),
    filters: {
      team: params.getAll('team[]').filter(item => item !== 'all'),
    }
  };

  return <PieBar
    apiParams={apiParams}
  />;
}

function StatisticsByTeamsChart3Portal({ id }: { id: string }) {
  const Root = document.getElementById(id);
  return Root ? createPortal(<EmployeesAge />, Root) : null;
}

export default StatisticsByTeamsChart3Portal;
